import { useContext, useEffect, useRef, useState } from "react";
import MolGrid, { Column } from "@moltech/molui/molgrid";
import { ContractContext } from "../../../../../../utils/context/ContractContext";
import { useAddContractScopesMutation, useContractScopesAvailableMutation } from "../../../../../../app/services/contractAPI";
import Checkbox from "../../../../../../components/finalForms/ui/inputs/checkBox/CheckBox";
import Buttons from "../../../../../../components/ui/button/Buttons";
import CardSection from "../../../../../../components/ui/card/CardSection";
import CustomCenterModel from "../../../../../../components/ui/customCenterModel/CustomCenterModel";
import { AppIcons } from "../../../../../../data/appIcons";
import NewScopes from "./features/NewContractScopes";
import FormCreator from "../../../../../../components/finalForms/FormCreator";
import { AddContractScopesFormConfig } from "./AddContractScopes.formfield.config";
import ToastService from "../../../../../../services/toastService/ToastService";


const AvailableContractScopes = ({ reloadScopes, setAvailableReload }) => {

  const { contractData, contractId } = useContext(ContractContext);
  const contractScopeRef = useRef();
  const [isScopeModelOpen, setIsScopeModelOpen] = useState(false);
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [availableScopesData, setAvailableScopesData] = useState([]);
  const [selectedCheckboxRows, setSelectedCheckboxRows] = useState([]);
  const [addScopesForm, setAddScopesForm] = useState(AddContractScopesFormConfig);

  const dtAsOfDate = contractData?.dtDateTermination !== null && new Date(contractData?.dtDateTermination) < new Date()
    ? new Date(contractData?.dtDateTermination)
    : new Date();

  const [AvailableContractScopes, {
    isFetching: isAvailableContractScopesFetching,
    isSuccess: iAvailableContractScopesFetched,
    data: AvailableContractScopesData,
  }] = useContractScopesAvailableMutation();

  const [addContractScopes, {
    isSuccess: isContractScopesAdded,
    data: ContractScopesData
  }] = useAddContractScopesMutation();
  
  useEffect(() => {
    if (contractData && contractId) {
      const req = {
        plContractKey: contractId,
        pdtAsOfDate: dtAsOfDate
      }
      AvailableContractScopes(req);
      const today = new Date();
      let formData = { ...AddContractScopesFormConfig }
      formData.initialState = {
        pdtendDate: contractData?.dtDateTermination && !isNaN(new Date(contractData.dtDateTermination)) ? new Date(contractData.dtDateTermination) : '',
        pdteffectiveDate: contractData?.dtDateEffective && new Date(contractData.dtDateEffective) > today ? new Date(contractData.dtDateEffective) : today,
      }
      setAddScopesForm(formData);
    }
  }, [contractData, contractId, isModelOpen])

  useEffect(() => {
    if (setAvailableReload) {
      setAvailableReload(() => loadAvailableScopes);
    }
  }, [setAvailableReload]);

  useEffect(() => {
    if (!isAvailableContractScopesFetching && iAvailableContractScopesFetched && AvailableContractScopesData) {
      setAvailableScopesData(AvailableContractScopesData);
    }
  }, [isAvailableContractScopesFetching, iAvailableContractScopesFetched, AvailableContractScopesData])

  const loadAvailableScopes = () => {
    const req = {
      plContractKey: contractId,
      pdtAsOfDate: dtAsOfDate
    };
    AvailableContractScopes(req);
  };

  useEffect(() => {
    if (isContractScopesAdded && ContractScopesData) {
      if (ContractScopesData) {
        ToastService.success(ContractScopesData?.errorMessage);
        setSelectedCheckboxRows([]);
        reloadScopes();
        loadAvailableScopes();
        handleCloseModel();
      }
    }
  }, [isContractScopesAdded, ContractScopesData]);

  const handleScopeModelClick = (rowData) => {
    setIsScopeModelOpen(true);
  };

  const handleCloseModel = () => {
    setIsScopeModelOpen(false);
    resetForm();
    setIsModelOpen(false);
    reloadScopes();
  };

  const handleSave = () => {
    const formData = contractScopeRef?.current?.getFormData();
    if (formData) {
      if (formData?.pdtendDate < formData?.pdteffectiveDate) {
        ToastService.warning("End Date Is Not Greater Than Effective Date");
        return
      }
      const req = {
        plContractKey: contractId,
        pdtStartDate: formData?.pdteffectiveDate,
        pdtEndDate: formData?.pdtendDate,
        scopes: selectedCheckboxRows.map(row => ({
          plScopeKey: row.lScopeKey,
          sSerialNumber: row.sSerialNumber
        }))
      };
      addContractScopes(req);
    }
  }

  const resetForm = () => {
    let formData = { ...AddContractScopesFormConfig }
    formData.initialState = {}
    setAddScopesForm(formData);
  }


  const availableScopesContent = () => {
    return (
      <div className="d-flex justify-content-end gap-3">
        <span className="mr-3 d-flex">
          <Checkbox
            label="Include Inactive"
            name="isContract"
          />
        </span>
        <Buttons
          buttonText="Add"
          buttonTypeClassName="btn blue-btn"
          titleText="Add Coverd Scope"
          onClick={() => setIsModelOpen(true)}
          isDisable={selectedCheckboxRows.length === 0}
        />
        <Buttons
          buttonText="New"
          onClick={handleScopeModelClick}
          buttonTypeClassName="btn blue-btn"
          titleText="Add New Scopes"
        />
      </div>
    );
  };

  return (
    <div>
      <div className="scrollable-grid col-12 available-department">
        <CardSection
          cardTitle={`Available Scopes`}
          customHeader={true}
          headerContent={availableScopesContent()}
        >
          <div className="scrollable-grid col-12">
            <MolGrid
              grouping
              expandableRowGroups={true}
              paginator={false}
              value={availableScopesData}
              scrollable
              scrollHeight="flex"
              filterDisplay="row"
              sortMode="single"
              showGridlines
              resizableColumns
              selection={selectedCheckboxRows}
              onSelectionChange={(e) => setSelectedCheckboxRows(e.value)}
              dataKey="lScopeKey"
            >
              <Column selectionMode="multiple" bodyStyle={{ textAlign: "center" }} />
              <Column field="sClientName1" header="Client" grouping sortable />
              <Column field="sDepartmentName" header="Department" bodyStyle={{ textAlign: "Center" }} grouping sortable />
              <Column field="sScopeTypeDesc" header="Model" grouping sortable />
              <Column field="sSerialNumber" header="Serial #" bodyStyle={{ textAlign: "Center" }} grouping sortable />
            </MolGrid>
          </div>
          <CustomCenterModel
            isOpen={isScopeModelOpen}
            useCustomBg={true}
            modalTitle={"New Scope"}
            contentClass="content-40"
            onClose={handleCloseModel}
            modalTitleIcon={AppIcons.AddIcon}
          >
            <NewScopes onClose={handleCloseModel} />

          </CustomCenterModel>
          <div>
            <CustomCenterModel
              isOpen={isModelOpen}
              useCustomBg={true}
              modalTitle={"Add Scope"}
              contentClass="content-35"
              onClose={handleCloseModel}
              modalTitleIcon={AppIcons.AddIcon}
              className="add-contract-department"
            >
              <FormCreator
                ref={contractScopeRef}
                config={addScopesForm}
              />
              <div className="d-flex justify-content-center button-submit mt-2">
                <Buttons
                  buttonText="Save"
                  buttonTypeClassName="btn blue-btn w-full"
                  onClick={handleSave}
                />
                <Buttons
                  buttonText="Cancel"
                  buttonTypeClassName="btn secondary-btn ml-4"
                  onClick={handleCloseModel}
                />
              </div>
            </CustomCenterModel>
          </div>
        </CardSection>
      </div>
    </div>
  )
}

export default AvailableContractScopes